export const dropReportsEndpointIds = {
    GENERATE_DROP_REPORT: 'GENERATE_DROP_REPORT',
    GENERATE_DROP_REPORT_TASK: 'GENERATE_DROP_REPORT_TASK',
};
